class Cliente {
    constructor() {

        this.id = 0;
        this.legal_name = "";
        this.fantasy_name = "";
        this.address = "";
        this.comuna = 0;
        this.state_id = 0;
        this.city_id = 0;
        this.phones = [];
        this.user_email = "";
        this.leads_email = "";
        this.contact_name = "";
        this.legal_representative = "";
        this.rut = "";
        this.giro = "";
        this.url = "";
        this.office_hours = "";
        this.credits = "";
        this.comments = "";
        this.sucursal_id = null;
        this.active = true;
        this.plan_id = 0;
        this.products = [];
        this.memberid = "";
        this.plan = {
            quantity: 0,
            premium: 0,
            code: 0,
            products: [],
            active: true,
            name: ""
        };
        this.additionalEmails = [];
        this.locked = false;
        this.create_date = new Date();
        this.published_date = new Date();
        this.locked_date = new Date();
        this.idu_dm = 0;
        this.update_date = new Date();
        this.foto_grande = "";
    }
}

export {
    Cliente
}
